import React, { useEffect, useState, useContext } from "react";
import { Form, Input, Button, Card, message, Spin, Typography, Row, Col, Divider } from "antd";
import { LockOutlined, UserOutlined, SaveOutlined, KeyOutlined } from "@ant-design/icons";
import AppLayout from "./components/UserDashboardLayout";
import { LanguageContext } from "./LanguageContext";

const { Title, Text } = Typography;

const cardStyle = {
  borderRadius: 12,
  boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
  border: "none",
  marginBottom: 20,
};

const sectionIconStyle = (color) => ({
  width: 40,
  height: 40,
  borderRadius: "50%",
  background: `linear-gradient(135deg, ${color[0]} 0%, ${color[1]} 100%)`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: `0 4px 12px ${color[2]}`,
  flexShrink: 0,
});

const primaryBtnStyle = {
  height: 40,
  borderRadius: 8,
  background: "linear-gradient(135deg, #1890ff 0%, #096dd9 100%)",
  border: "none",
  fontWeight: 600,
  boxShadow: "0 4px 12px rgba(24,144,255,0.35)",
};

const UserProfileUpdate = () => {
  const [form] = Form.useForm();
  const [passwordForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const userId = localStorage.getItem("userId");
  const { language, translations } = useContext(LanguageContext);

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      try {
        const res = await fetch(
          `https://json-configrator-api.root.myoctoopidev.com/User/GetById/${userId}`
        );
        const json = await res.json();
        if (json.success) {
          form.setFieldsValue(json.data);
        } else {
          message.error("Kullanıcı verileri alınamadı.");
        }
      } catch {
        message.error("Bir hata oluştu.");
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
  }, [form, userId]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await fetch(
        "https://json-configrator-api.root.myoctoopidev.com/User/Update",
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...values,
            id: userId,
            role: true,
            companyId: "00000000-0000-0000-0000-000000000000",
            updateDate: new Date().toISOString(),
          }),
        }
      );
      const json = await res.json();
      if (json.success) {
        message.success(translations[language].profilbg);
      } else {
        message.error(translations[language].profilbas);
      }
    } catch {
      message.error(translations[language].bhataol);
    } finally {
      setLoading(false);
    }
  };

  const onPasswordFinish = async (values) => {
    setPasswordLoading(true);
    try {
      const res = await fetch(
        "https://json-configrator-api.root.myoctoopidev.com/User/UpdatePassowrd",
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: userId, password: values.newPassword }),
        }
      );
      const json = await res.json();
      if (json.success) {
        message.success(translations[language].passwordSuccess);
        passwordForm.resetFields();
      } else {
        message.error(translations[language].profilbas);
      }
    } catch {
      message.error(translations[language].bhataol);
    } finally {
      setPasswordLoading(false);
    }
  };

  return (
    <AppLayout>
      <div style={{ padding: 20 }}>

        {/* Profil Bilgileri Kartı */}
        <Card style={cardStyle} bodyStyle={{ padding: 28 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 24 }}>
            <div style={sectionIconStyle(["#1890ff", "#096dd9", "rgba(24,144,255,0.25)"])}>
              <UserOutlined style={{ fontSize: 18, color: "#fff" }} />
            </div>
            <div>
              <Title level={4} style={{ margin: 0, fontWeight: 700, color: "#262626" }}>
                {translations[language].profbilgi}
              </Title>
              <Text style={{ color: "#8c8c8c", fontSize: 13 }}>
                {translations[language].name} / {translations[language].email}
              </Text>
            </div>
          </div>

          <Divider style={{ margin: "0 0 24px" }} />

          {loading ? (
            <div style={{ textAlign: "center", padding: 40 }}>
              <Spin size="large" />
            </div>
          ) : (
            <Form form={form} layout="vertical" onFinish={onFinish}>
              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <Form.Item label={translations[language].name} name="name" rules={[{ required: true }]}>
                    <Input prefix={<UserOutlined style={{ color: "#bfbfbf" }} />} style={{ borderRadius: 8, height: 40 }} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item label={translations[language].surname} name="surname" rules={[{ required: true }]}>
                    <Input style={{ borderRadius: 8, height: 40 }} />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item label={translations[language].email} name="email" rules={[{ required: true, type: "email" }]}>
                    <Input style={{ borderRadius: 8, height: 40 }} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item label={translations[language].fa} name="companyName">
                    <Input style={{ borderRadius: 8, height: 40 }} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item label={translations[language].ka} name="caravanType">
                    <Input style={{ borderRadius: 8, height: 40 }} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item label={translations[language].customerPhone} name="customerPhone">
                    <Input style={{ borderRadius: 8, height: 40 }} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item label={translations[language].country} name="customerCountry">
                    <Input style={{ borderRadius: 8, height: 40 }} />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item label={translations[language].description} name="description">
                    <Input.TextArea rows={3} style={{ borderRadius: 8 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  icon={<SaveOutlined />}
                  style={primaryBtnStyle}
                >
                  {translations[language].update}
                </Button>
              </Form.Item>
            </Form>
          )}
        </Card>

        {/* Şifre Güncelle Kartı */}
        <Card style={cardStyle} bodyStyle={{ padding: 28 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 24 }}>
            <div style={sectionIconStyle(["#722ed1", "#531dab", "rgba(114,46,209,0.25)"])}>
              <KeyOutlined style={{ fontSize: 18, color: "#fff" }} />
            </div>
            <div>
              <Title level={4} style={{ margin: 0, fontWeight: 700, color: "#262626" }}>
                {translations[language].passwordUpdateTitle}
              </Title>
              <Text style={{ color: "#8c8c8c", fontSize: 13 }}>
                {translations[language].newPassword} / {translations[language].confirmPassword}
              </Text>
            </div>
          </div>

          <Divider style={{ margin: "0 0 24px" }} />

          <Form form={passwordForm} layout="vertical" onFinish={onPasswordFinish}>
            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item
                  label={translations[language].newPassword}
                  name="newPassword"
                  rules={[{ required: true, message: translations[language].passwordMismatch }]}
                >
                  <Input.Password
                    prefix={<LockOutlined style={{ color: "#bfbfbf" }} />}
                    placeholder="••••••••"
                    style={{ borderRadius: 8, height: 40 }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  label={translations[language].confirmPassword}
                  name="confirmPassword"
                  dependencies={["newPassword"]}
                  rules={[
                    { required: true, message: translations[language].passwordMismatch },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("newPassword") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error(translations[language].passwordMismatch));
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined style={{ color: "#bfbfbf" }} />}
                    placeholder="••••••••"
                    style={{ borderRadius: 8, height: 40 }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={passwordLoading}
                icon={<LockOutlined />}
                style={{
                  ...primaryBtnStyle,
                  background: "linear-gradient(135deg, #722ed1 0%, #531dab 100%)",
                  boxShadow: "0 4px 12px rgba(114,46,209,0.35)",
                }}
              >
                {translations[language].update}
              </Button>
            </Form.Item>
          </Form>
        </Card>

      </div>
    </AppLayout>
  );
};

export default UserProfileUpdate;
